import React from 'react';
import Icon from '../../components/icons';
import moment from 'moment';
import { ReviewModalProps } from '../../_config/interfaces/interfaces';
import { showDate } from '../../_common/functions';

const ReviewDetailsModal: React.FC<ReviewModalProps> = ({ isOpen, onClose, reviewDetails }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50 w-full h-full">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full overflow-y-auto" style={{ maxHeight: '80vh' }}>
        <div className="relative flex flex-col items-center">
          {/* Heading */}
          <h3 className="text-2xl font-semibold text-center text-gray-800">
            Reviews
          </h3>
          <Icon name="close" className="absolute -top-1 right-0 p-2 text-gray-500 cursor-pointer" onClick={() => onClose()} />

          <hr className="border-t border-gray-300 w-full mb-4" />

          {Object.keys(reviewDetails).map((sentiment: any, index: any) => {
            const sentimentData = reviewDetails[sentiment];
            if (!sentimentData || sentimentData.count === 0) return null;

            let sentimentClass = '';
            if (sentiment === 'positive') {
              sentimentClass = 'border-green-600';
            } else if (sentiment === 'negative') {
              sentimentClass = 'border-red-600';
            } else if (sentiment === 'mixed') {
              sentimentClass = 'border-gray-600';
            } else {
              sentimentClass = 'border-yellow-600';
            }

            return (
              <div className="w-full mb-2" key={index}>

                {sentimentData?.reviews?.map((review: any, index: number) => (
                  <div key={review.feedback_id} className="mb-3">
                    <div className={`flex flex-col sm:flex-row sm:space-x-8 mb-3 border-l-4 ${sentimentClass}`}>

                      <div className="flex flex-col sm:w-2/3">
                        <p className={`text-sm p-4`}>{review.review_text}</p>
                      </div>

                      <div className="flex flex-col sm:w-1/3 text-sm text-gray-700 sm:mt-0 justify-end items-end p-4">
                        <div className={`text-sm font-semibold mb-2`}>{review.customer_name}</div>
                        <div className={`text-sm mb-2`}>{showDate(review?.posting_date,'YYYY-MM-DD')}</div>
                        {/* <div className="mt-2 text-sm text-gray-500 capitalize">{review.sentiment}</div> */}
                      </div>
                    </div>
                    <hr className="border-t border-gray-300 w-full mb-4" />
                  </div>
                ))}
              </div>
            );
          })}

        </div>
      </div>
    </div>
  );
};

export default ReviewDetailsModal;
